export const devices = {
   mobile: `@media (min-width: 540px)`,
   mobileL: `@media (min-width: 640px)`,
   tablet: `@media (min-width: 768px)`,
   tabletL: `@media (min-width: 1024px)`,
   tabletXL: `@media (min-width: 1200px)`,
   desktop: `@media (min-width: 1366px)`,
   desktopHD: `@media (min-width: 1600px)`,
   desktopFHD: `@media (min-width: 1740px)`
};
